export default "__VITE_ASSET__65cd385d__"